class NavigationMobile extends HTMLElement {
  constructor() {
    super();

    this.media = window.matchMedia("screen and (min-width: 414px)");

    this.activeHandle = "";
    this.links = this.querySelectorAll(".navigation-menu__link");
    this.banners = this.querySelectorAll(".navigation-menu__item--banner");

    this.addEventListener("click", (evt) => {
      const handle = evt.target.closest("[data-handle]");
      const url = evt.target.closest("[data-url]");
      const drop = evt.target.closest("[data-drop]");
      // const close = evt.target.closest(".cart-close");

      if (!handle || !url || !drop) return;

      if (
        drop.dataset.drop === "true" &&
        handle.dataset.handle !== this.activeHandle
      ) {
        this.updateLink(handle);
        return;
      }

      if (
        drop.dataset.drop === "true" &&
        handle.dataset.handle === this.activeHandle
      ) {
        this.updateLink("");
        return;
      }

      window.location.assign(url.dataset.url);
    });
  }

  updateLink(handle) {
    this.activeHandle = handle === "" ? "" : handle.dataset.handle;

    this.links.forEach((link) => {
      link.classList.toggle(
        "active",
        link.dataset.handle === this.activeHandle
      );
    });

    this.banners.forEach((banner) => {
      banner.classList.toggle(
        "active",
        banner.dataset.banner === this.activeHandle
      );
    });
  }
}

customElements.define("navigation-mobile", NavigationMobile);
